import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RefundRequest from "./refundRequest";
import {
    completeMeeting,
    cxOrderRefundList
} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    complete: state.baMeetingReducer.complete,
    refundList: state.baMeetingReducer.refundList,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            completeMeeting,
            cxOrderRefundList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RefundRequest);
